import axios from "axios";
import lstool from "./localStorage";
import { responseExtracor } from "./general";
const baseUrl = "https://app.rashinstar.ir/api.aspx";

// const fetchWithoutTokenInstance = axios.create({
//   baseURL: baseUrl,
//   headers: { "Content-Type": "application/json" }
// });
const fetchModule = axios.create({
  baseURL: baseUrl,
  params: {
    ...(lstool.check() ? { userid: lstool.get() } : {}),
  },
});
fetchModule.interceptors.response.use(
  (res) => {
    if (res.data === "user is invalid") {
      window.localStorage.clear();
      window.location = window.location.toString().split("app")[0];
    }
    return res.data;
  },
  (err) => err
);
export default fetchModule;
